import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const Container = styled.div`
  align-self: center;
  background-color: white;
  border-radius: 1px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 560px;
  min-width: 288px;
  position: relative;
  width: calc(100vw - 32px);
`;

export const Content = styled.div`
  height: 100%;
  padding: 0px 32px;
`;

export const Headline = styled.div`
  padding: 32px 32px 16px 32px;

  h3 {
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
  }
`;

export const Wrapper = styled.div`
  align-items: center;
  animation: 200ms ${fadeIn} ease-out;
  background-color: rgba(0, 0, 0, 0.6);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  overflow: auto;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 100;
`;
